import React from 'react';
import PropTypes from 'prop-types';
import PosterFormatType from 'components/posters/PosterFormatType';
import { Link } from 'react-router-dom';

const SpecialItem = ({
  d,
  styles,
  size,
  sizeAlt,
  row,
  redirect,
  children = null,
}) => (
  <div
    className="jcarousel-item-1 jcarousel-item row"
    style={{
      background: `#${styles.boxcolor}`,
      color: `#${styles.fontcolor}`,
    }}
  >
    <div
      className={`${
        row ? 'col-md-6 col-xs-12 col-xs-12' : 'col-md-8 col-xs-12 col-sm-12'
      } image`}
    >
      <div className="item-wrapper" style={{ paddingLeft: 0 }}>
        <Link className="item-img" to={redirect.redirectUrl}>
          <img
            className={row ? '' : 'hidden-sm hidden-xs'}
            src={d[size]}
            alt={d.title}
          />
          {!row && (
            <img
              className="visible-sm visible-xs"
              src={d[sizeAlt]}
              alt={d.title}
            />
          )}
          <PosterFormatType
            item={{
              proveedor_name: d.proveedor_name,
              proveedor_code: d.proveedor_code,
              live_enabled: d.live_enabled || d?.liveType,
              format_types: d.format_types,
            }}
          />
        </Link>
      </div>
    </div>
    <div
      className={`${
        row ? 'col-md-6 hidden-sm hidden-xs' : 'col-md-4 hidden-sm hidden-xs'
      } data`}
    >
      <b
        style={{ color: `#${styles.boxcolor}` }}
        className="fa fa-caret-left"
      />
      <h3 className="h3-special">{d.title}</h3>
      {!row && <p className="item-description">{d.description}</p>}
      <div className="btn-toolbar">{children}</div>
    </div>
  </div>
);

SpecialItem.propTypes = {
  d: PropTypes.object,
  redirect: PropTypes.object,
  styles: PropTypes.object,
  row: PropTypes.bool,
  size: PropTypes.string,
  sizeAlt: PropTypes.string,
  children: PropTypes.array,
};

SpecialItem.defaultProps = {
  row: false,
};

export default SpecialItem;
